import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../../service/common.service';
import { Commessa } from '../../models/commessa';
import { User } from '../../models/user';
import { Orfriaudit } from '../../models/orfriaudit';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { configurazione } from '../../../configurazioni/configurazione';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';

@Component({
  selector: 'app-audit',
  templateUrl: './audit.component.html',
  styleUrls: ['./audit.component.css']
})
export class AuditComponent implements OnInit {
  selectedValueUser:string;
  selectedValueCommessa:string;
  selectedValueDatainizio:Date;
  selectedValueDatafine:Date;
  orfriaudits: Orfriaudit[]=[];
  users: User[]=[];
  user: User;
  commesse: Commessa[]=[];
  commessa: Commessa;
  filtroCommessa: string;

//  currentAzienda:Azienda;
  displayedColumns: string[] = [
    "Id",
    "Codicecommessa",
    "Nomelavorazione",
    "Statoiniziale",
    "Statofinale",
    "Dataazione",
    "Timeazione"];


  sortedDirection:Map<string, boolean>=new Map<string, boolean>();
  dataSource = new MatTableDataSource<Orfriaudit>(this.orfriaudits);

  @ViewChild('paginator') paginator: MatPaginator;
  selection = new SelectionModel<Orfriaudit>(true, []);

  constructor(private router: Router, private commonService: CommonService) {
//    this.commessa=new Commessa();
    this.filtroCommessa="";
  }

  ngOnInit() {
//    this.commonService.getAllStaticommessa().subscribe((res) => {
//        this.stati = res;
//        if (this.commonService.selectedStatocommessa!=undefined) {
//            this.selectedValueStato=this.commonService.selectedStatocommessa.Nome;
//        }
/*
        this.commesse.forEach(element => {
          if (element.Codice === this.commonService.currentAziendaCodice){
            this.stato=element;
            this.selectedValueAzienda=this.azienda.Nome;
          }
        });
*/
  //      this.manageChangeAzienda();
//        this.manageChangeStato();
  //      this.aggiornaLista();
//    });

    this.commonService.getUsers(this.getConfigurazione().istanzaorfri).subscribe((res) => {
      this.users=res;
    });



    this.dataSource.paginator = this.paginator;
    this.sortedDirection.set("Id",true);
    this.sortedDirection.set("Utente",true);
    this.sortedDirection.set("Codicecommessa",true);
    this.sortedDirection.set("Nomelavorazione",true);
    this.sortedDirection.set("Statoiniziale",true);
    this.sortedDirection.set("Statofinale",true);
  }

  manageChangeUser(){
    if (this.selectedValueUser!=undefined){
      this.users.forEach(element => {
        if (this.selectedValueUser === element.Username){
          this.user=element;
        }
      });
      this.commonService.getCommesseByPersona(this.user.Codicepersona).subscribe((res) => {
        this.commesse = res;
        if (res.length===0){
          alert('Non ci sono commesse associate all\'utente selezionato');
        }
      });
    }
    this.aggiornaLista();
  }

  manageChangeCommessa(){
    if (this.selectedValueCommessa!=undefined){

    }
    this.aggiornaLista();
  }

  selezionata(commessa:Commessa){
    console.log("");
    /*
    const indexOfObject = this.articoliselezionati.findIndex((element) => {
      return element.Codicearticolo === articolo.Codicearticolo;
    });
    if (indexOfObject !== -1) {
      this.articoliselezionati.splice(indexOfObject, 1);
    }else{
      this.articoliselezionati.push(articolo);
    }
    */
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
        this.selection.clear() :
        this.dataSource.data.forEach(row => this.selection.select(row));
  }
/*
  manageCheckboxclick(event, c:Commessa){
    this.commesseselezionate=[];
    this.commessa=c;
    let found:boolean=false;
    this.selection.selected.forEach(row => {
      if (row.Codice!=c.Codice){
        this.selection.deselect(row);
      }else{
        found=true;
        this.commesseselezionate.push(c);
      }
    });
    if (!found){
      this.commessa=new Commessa();
      this.commesseselezionate=[];
    }
    this.dataSource2 = new MatTableDataSource<Commessa>(this.commesseselezionate);

    event.stopPropagation();
  }
*/
  cancel(){
    this.selectedValueUser="";
    this.selectedValueCommessa="";
    this.selectedValueDatainizio=undefined;
    this.selectedValueDatafine=undefined;
    this.commesse=[];
    this.filtroCommessa="";
    this.orfriaudits=[];
    this.selection.clear();
    this.aggiornaLista();
  }


  aggiornaLista(){
    let templista:Orfriaudit[]=[];
    this.orfriaudits=[];
     this.commonService.getAllOrfriaudits(this.user.Username).subscribe((res) => {
       templista = res;
       this.refreshLista(templista);
      });
    }

   refreshLista(lista:Orfriaudit[]){
     this.orfriaudits=lista;
     this.dataSource = new MatTableDataSource<Orfriaudit>(this.orfriaudits);
     this.dataSource.paginator = this.paginator;
   }



  getConfigurazione(){
    return configurazione;
  }


  isDetailsHidden(){
    if (this.selection.selected.length===0){
      return 'none';
    }else{
      return'';
    }
  }

  onFiltrofiltroCommessaKeyup(event:any){
      this.orfriaudits = this.orfriaudits.filter(o => o.Commessa.Numerocommessa.toString().indexOf(event.target.value)>-1);
      this.dataSource = new MatTableDataSource<Orfriaudit>(this.orfriaudits);
  }

  onFiltroDatainizioDatechange(event:any){
    let di=this.dateToNumber(this.selectedValueDatainizio);
    let df=this.dateToNumber(this.selectedValueDatafine);
    let temp:Orfriaudit[]=[];

      this.orfriaudits.forEach(o => {
        let daz=this.dateToNumber(o.Dataazione);
        if (di<=daz && daz<=df){
          temp.push(o);
        }
      })
      this.orfriaudits=temp;
      this.dataSource = new MatTableDataSource<Orfriaudit>(this.orfriaudits);

  }



  dateToNumber(d: Date): number {
    let s:string='99991231';
    if(d!=undefined && d!=null){

      if (d instanceof Date){
//        console.log("--->"+d);
      }else{
        let s2=String(d).replaceAll('-','')
//        console.log("not date:"+s2);
        return Number(s2);
      }

      let month:string = (d.getMonth()+1).toString();
      if ((d.getMonth()+1)<10){
        month='0'+month;
      }
      let year = d.getFullYear().toString();
      let day = d.getDate().toString();
      s=year+month+day;
    }
    return Number(s);
  }


  manageClick(attributo: string){
    let tempList:Commessa[];
    tempList=this.commesse;
    let direction=this.sortedDirection.get(attributo);

    tempList.sort((a, b) => {
       var typeA = "";
       var typeB = "";
       if (a[attributo]!=null){
         if (isNaN(b[attributo]))
            typeA = a[attributo].toLowerCase();
         else
            typeA = a[attributo].toString();
       }
       if (b[attributo]!=null){
         if (isNaN(b[attributo]))
            typeB = b[attributo].toLowerCase();
          else
            typeB = b[attributo].toString();
       }
         if (direction){
           if (typeA > typeB){
             return -1;
           }else if (typeA < typeB){
              return 1;
           }else{
             return 0;
           }
         }else{
           if (typeA < typeB){
             return -1;
           }else if (typeA > typeB){
              return 1;
           }else{
             return 0;
           }
         }
     });
     direction=!direction;
     this.sortedDirection.set(attributo,direction);
     this.dataSource = new MatTableDataSource<Orfriaudit>(this.orfriaudits);

   }



}
